export const formatFullName = (firstName: string, lastName: string, reverse?: boolean) =>
  !reverse ? `${firstName} ${lastName}` : `${lastName} ${firstName}`;
